<template lang="pug">
  footer.footer
    .container
      .row
        .footer__container
          .footer__information.col-lg-4.col-md-4
            RouterLink.footer__logo(:to="$i18nRoute({ name: 'Index' })")
              img(src="@/assets/images/logotype.png" alt="Infinity Meds")
            p.footer__information-text {{ $t('layout.footer.description') }}

          .footer__menu.col-lg-4.col-md-4.col-sm-12(v-if="!isTablet")
            h4.footer__title {{ $t('layout.footer.menu_title') }}
            FooterMenu

          ExpandableItem.footer__expandable(v-else)
            template(#toggle)
              h3.footer__expandable-title.expandable__title
                span {{ $t('layout.footer.menu_title') }}
                BaseIcon.expandable__chevron(name="chevron")
            template(#expandable)
              .footer__menu
                FooterMenu

          .footer__contact.col-lg-4.col-md-4.col-sm-12(v-if="!isTablet")
            FooterContacts

          ExpandableItem.footer__expandable(v-else)
            template(#toggle)
              h3.footer__expandable-title.expandable__title
                span {{ $t('layout.footer.store_information') }}
                BaseIcon.expandable__chevron(name="chevron")
            template(#expandable)
              .footer__contact
                FooterContacts
</template>

<script setup lang="ts">
import { defineComponent, h } from 'vue'
import { storeToRefs } from 'pinia'
import { RouterLink } from 'vue-router'
import BaseIcon from '@/components/common/BaseIcon.vue'
import ExpandableItem from '@/components/common/ExpandableItem.vue'
import { useUiStore } from '@/stores/ui'
import { i18n } from '@/i18n'
import { localizedRoute } from '@/composables/useLocalizedRoute'
import pinImage from '@/assets/images/pin.png'
import emailImage from '@/assets/images/email.png'
import phoneImage from '@/assets/images/phone.png'

const { isTablet } = storeToRefs(useUiStore())

const FooterMenu = defineComponent({
  name: 'FooterMenu',
  setup() {
    const links = [
      ['About', 'menu.about_us'],
      ['Delivery', 'menu.delivery_information'],
      ['Privacy', 'menu.privacy_policy'],
      ['TermsAndConditions', 'menu.terms_conditions'],
      ['Information', 'menu.information'],
    ] as const

    return () =>
      h(
        'ul',
        { class: 'footer__list' },
        links.map(([name, label]) =>
          h('li', { class: 'footer__item' }, [
            h(RouterLink, { to: localizedRoute({ name }) }, () => i18n.global.t(label)),
          ]),
        ),
      )
  },
})

const FooterContacts = defineComponent({
  name: 'FooterContacts',
  setup() {
    const contacts = [
      {
        image: pinImage,
        title: 'layout.footer.address',
        value: '220-530 Century StreetWinnipeg, MB R3H 0Y4',
      },
      {
        image: emailImage,
        title: 'layout.footer.social',
        value: 'infinity69@tutanota.com',
        href: 'mailto:infinity69@tutanota.com',
      },
      {
        image: phoneImage,
        title: 'layout.footer.contact',
        value: '+8470 5048736',
        href: 'tel:+84705048736',
      },
    ]

    return () =>
      contacts.map((contact) =>
        h('div', { class: 'footer__contact-item' }, [
          h('div', { class: 'footer__contact-icon' }, [h('img', { src: contact.image, alt: '' })]),
          h('div', { class: 'footer__contact-content' }, [
            h('div', { class: 'footer__contact-title' }, i18n.global.t(contact.title)),
            contact.href
              ? h('a', { class: 'footer__contact-description', href: contact.href }, contact.value)
              : h('div', { class: 'footer__contact-description' }, contact.value),
          ]),
        ]),
      )
  },
})
</script>
